<template>
  <div>
    <section class="">
			<div class="container">
				<figure>
          <img src="/static/images/index/i80banner.png" class="img-responsive">
        </figure>
			</div>
		</section>
    <section>
      <div class="container">
        <ol class="breadcrumb hidden-xs">
            <li><a href="/">首頁</a></li>
            <li><a href="/store">商品查詢</a></li>
        </ol>
        <h4 class="title">商品查詢</h4>
        <div class="row">
            <form class="navbar-form" @submit.prevent>
                <div class="form-group">
                    <input type="text" v-model="keyword" class="form-control" placeholder="關鍵字">
                </div>
                <button type="button" @click="SearchProduct()" :disabled="this.flag" class="btn btn-success">查詢</button>
            </form>
        </div>
        <hr>
        <div class="row clear">

<paginate
  name="products"
  :list="products"
  :per="12"
  tag="div"
  class="paginate-langs"
>
  <div class="col-md-3 col-sm-4 col-xs-6" v-for="item in paginated('products')">
    <div class="product_box">
      <figure class="pic justify">
        <router-link :to="'/product/'+item.id">
          <img :src="'https://files.i80.com.tw/images/product/'+item.imageM" class="img-responsive"/>
        </router-link>
      </figure>
      <h5 class="title">{{ item.name }}</h5>
      <p class="points" v-if="item.price > 0">
        <span class="glyphicon glyphicon-gift" aria-hidden="true"></span>{{ item.point }}點
      </p>
      <p class="price" v-if="item.price > 0">{{item.price}}</p>
      <button class="addcart btn btn-default i80_btn" type="button" @click="ADD_TO_CART(item)" v-if="item.price > 0">
        <span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span> 加入購物車
      </button>
    </div>
  </div>
</paginate>
        </div>
<center>
  <nav aria-label="Page navigation example">
  <paginate-links
    for="products"
    :classes="{
      'ul': ['pagination','pagination-sm'],
      'li': 'page-item'
    }"
  ></paginate-links>
  </nav>
</center>
      </div>
    </section>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'SearchProduct',
  data () {
    return {
      apiurl: 'https://affiliate.i80.com.tw/',
      originProduct: Object,
      products: [],
      rowData: {},
      userID: this.$store.getters.getUserID,
      paginate: ['products'],
      keyword: '',
      category: [],
      categorySelected: 0,
      flag: false
    }
  },
  created: function () {
  },
  computed: {
    ...mapGetters([
      'getCompanies'
    ])
  },
  methods: {
    ...mapActions([
      'ADD_TO_CART'
    ]),
    SearchProduct () {
      let vm = this
      let keyword = this.keyword
      if (keyword !== '' && keyword.length > 1) {
        vm.products = []
        this.$http.post(this.apiurl + 'api/product/search', {
          keyword: keyword
        }).then(function (res) {
          vm.flag = false
          let data = res.body.data
          if (data.length === 0) {
            window.alert('查無商品，請重新輸入。')
            return false
          }
          vm.products = data
        }, function () {
          console.log('failed')
        })
      } else {
        window.alert('請輸入關鍵字。')
      }
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// SearchProduct.vue?5b12a31a